import { render, staticRenderFns } from "./CtaBanner.vue?vue&type=template&id=8a231292"
import script from "./CtaBanner.vue?vue&type=script&lang=js"
export * from "./CtaBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports